import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    applicationServerKey: String,
    subscribeUrl: { type: String, default: '/admin/push_subscriptions' },
    serviceWorkerUrl: { type: String, default: '/admin-sw.js' }
  }

  connect () {
    this.init()
  }

  async init () {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return

    try {
      const registration = await navigator.serviceWorker.register(this.serviceWorkerUrlValue, { scope: '/admin' })
      await navigator.serviceWorker.ready

      let subscription = await registration.pushManager.getSubscription()

      if (!subscription && window.Notification.permission === 'granted') {
        subscription = await this.subscribe(registration)
      } else if (window.Notification.permission === 'default') {
        const permission = await window.Notification.requestPermission()
        if (permission === 'granted') {
          subscription = await this.subscribe(registration)
        }
      }

      if (subscription) {
        await this.sendToServer(subscription)
      }
    } catch (e) {
      console.error('[Push]', e)
    }
  }

  async subscribe (registration) {
    return registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlBase64ToUint8Array(this.applicationServerKeyValue)
    })
  }

  async sendToServer (subscription) {
    const body = {
      subscription: {
        endpoint: subscription.endpoint,
        p256dh_key: this.toBase64(subscription.getKey('p256dh')),
        auth_key: this.toBase64(subscription.getKey('auth'))
      }
    }

    await fetch(this.subscribeUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
      },
      body: JSON.stringify(body)
    })
  }

  toBase64 (buffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
  }

  urlBase64ToUint8Array (base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
    const raw = atob(base64)
    return Uint8Array.from(raw, c => c.charCodeAt(0))
  }
}
